export default function isStockImage(imageUrl: string): boolean {
  return (
    imageUrl.startsWith("https://s3.amazonaws.com/static.govlaunch.com") ||
    imageUrl.startsWith("https://static.govlaunch.com/resources/gallery")
  );
}
